import { Button, HFlow, Text, VFlow } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { ACOMPANHAMENTO_TERRITORIO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import { LoadingIndicator } from 'components/loading'
import { format } from 'date-fns'
import { css } from 'emotion'
import { useVisualizarImovelHeaderQuery } from 'graphql/hooks.generated'
import { useHistory, useParams } from 'react-router'
import { useCadastroImovelCache } from 'view/cadastro-imovel/hooks/useCadastroImovelCache'
import { StatusCadastroImovelTag } from 'view/visualizacaoTerritorial/components/list/StatusCadastroImovelTag'

import { ImovelUrlParams } from '../model-visualizacao-imovel'
import { createImovelNotFoundError, getCallbackTabByString } from '../utils-visualizacao-imovel'
import { convertImovelDtoToImovelHeaderDto } from '../visualizacao-imovel-converter'
import { VisualizarImovelHeaderContent } from './VisualizarImovelHeaderContent'
import { VisualizarImovelHeaderTabs } from './VisualizarImovelHeaderTabs'

export function VisualizarImovelHeader() {
  const { imovelId } = useParams<ImovelUrlParams>()
  const { data, loading, error } = useVisualizarImovelHeaderQuery({
    variables: {
      input: imovelId,
    },
    fetchPolicy: 'network-only',
  })

  const { dataUltimaAtualizacao, isCadastroCompleto, tipoEndereco, statusRecusa, stAtivo } = data?.imovel || {}

  const history = useHistory()
  const { acesso } = useAcessoLotacaoOrEstagio()
  const { deleteCacheState } = useCadastroImovelCache(acesso.id)

  if (loading) {
    return <LoadingIndicator />
  }

  if (error) {
    throw error
  }

  if (!data?.imovel) {
    throw createImovelNotFoundError('VisualizarImovelHeader', imovelId)
  }

  const callbackTab = getCallbackTabByString(history.location.pathname.split('/').pop())

  const handleAtualizarImovelClick = () => {
    setTimeout(() => {
      deleteCacheState()
      setTimeout(() => {
        history.push(`${ACOMPANHAMENTO_TERRITORIO_PATH}/editarImovel/${imovelId}?redirect=${callbackTab}`)
      })
    })
  }

  return (
    <VFlow>
      <HFlow
        style={css`
          padding: 1rem;
        `}
        justifyContent='space-between'
      >
        <VisualizarImovelHeaderContent imovel={convertImovelDtoToImovelHeaderDto(data.imovel)} />
        <VFlow
          vSpacing={0.4}
          style={css`
            align-items: flex-end;
          `}
        >
          <Button type='button' kind='primary' size='small' onClick={handleAtualizarImovelClick}>
            Atualizar cadastro
          </Button>
          <Text>{`Última atualização em ${dataUltimaAtualizacao && format(dataUltimaAtualizacao, 'dd/MM/yyyy')}`}</Text>
          <HFlow hSpacing={0.5}>
            <Text
              style={css`
                margin-top: 0.2rem;
              `}
            >
              Situação de cadastro:
            </Text>
            <StatusCadastroImovelTag
              isCadastroCompleto={isCadastroCompleto}
              isStatusRecusaCadastro={statusRecusa}
              stAtivo={stAtivo}
            />
          </HFlow>
        </VFlow>
      </HFlow>

      <VisualizarImovelHeaderTabs tipoEndereco={tipoEndereco} isStatusRecusaCadastro={statusRecusa} />
    </VFlow>
  )
}
